const primaryHeaderHeight = 90;
const scrollOffset = 40;

const SELECTOR = ".js-table-of-contents";
const CSS = {
  active: "table-of-contents__link--active",
  initialised: "table-of-contents__items--initialised",
};

const instance = ($el: Element) => {
  const target = $el.getAttribute("data-target") as string;

  if (!target) {
    return;
  }

  const $content = document.querySelector(target) as HTMLElement;

  if (!$content) {
    return;
  }

  const $headings = $content.querySelectorAll("h2");

  if (!$headings.length || $headings.length == 1) {
    return;
  }

  const existingHeadings: string[] = [];
  const anchorLinks: HTMLElement[] = [];

  // Add all existing ids on the page to the existingHeadings array
  document.querySelectorAll("[id]").forEach(($el) => {
    if ($el.id) {
      existingHeadings.push($el.id);
    }
  });

  //For each heading...
  $headings.forEach(($heading) => {
    // Add an id to the heading if it doesn't have one
    if (!$heading.textContent) {
      return;
    }

    if (!$heading.id) {
      let newId = "";
      const generatedId = $heading.textContent
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");

      // Ensure heading id is unique by appending the number of times it already appears in the array
      if (existingHeadings.includes(generatedId)) {
        const count = existingHeadings.filter(
          (heading) => heading === generatedId,
        ).length;
        newId = `${generatedId}-${count + 1}`;
      } else {
        newId = generatedId;
      }

      existingHeadings.push(generatedId);

      $heading.id = newId;
    }

    //Add an $anchorLink link to the table of contents
    const $anchorLink = document.createElement("a");
    $anchorLink.href = `#${$heading.id}`;
    $anchorLink.textContent = $heading.textContent as string;
    $anchorLink.classList.add("table-of-contents__link");
    $anchorLink.setAttribute("data-scroll", "");
    $el.appendChild($anchorLink);
    anchorLinks.push($anchorLink);
  });

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY;

    // highlight the last scrolled to
    anchorLinks.forEach((link) => {
      link.classList.remove(CSS.active);
    });

    // then iterate backwards, on the first match highlight it and break
    let highlighted = false;
    for (let i = $headings.length - 1; i >= 0; i--) {
      if (
        scrollTop >
        ($headings[i] as HTMLHeadingElement).getBoundingClientRect().top -
          primaryHeaderHeight -
          scrollOffset
      ) {
        anchorLinks[i].classList.add(CSS.active);
        highlighted = true;
        break;
      }
    }

    // If nothing's highlighted, highlight the first link
    if (highlighted === false) {
      anchorLinks[0].classList.add(CSS.active);
    }
  });

  $el.classList.add(CSS.initialised);
};

const tableOfContents = () => {
  document.querySelectorAll(SELECTOR).forEach(($el: Element) => {
    instance($el);
  });
};

export default tableOfContents;
